import arraysIntersect from 'helpers/arrays/arraysIntersect';

const userHasRoles = (requiredRoles: string[], userRoles: string[]): boolean => {
    return arraysIntersect(requiredRoles, userRoles).length > 0 || requiredRoles.length === 0
}

export default userHasRoles;